import * as E from "~/renderer/web-components/element";

export class TextView extends E.SFMLCullingElement {

  public get value(): string {
    return this.textContent || "";
  }

  public get maxLines(): Number {
    const maxLines = this.getAttribute("max-lines");
    return Number(maxLines) || 1;
  }

  public set value(value: string) {
    this.textContent = value;
  }

  public set maxLines(maxLines: Number) {
    this.setAttribute("max-lines", maxLines.toString());
  }
}

customElements.define("sfml-textview", TextView);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/layout/text.ts